import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Input,
  Col,
  Form,
  FormGroup,
  Label
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button, Statistics, BillsTable } from "components";

import { thead, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
// react plugin used to create datetimepicker
import Datetime from "react-datetime";
import { v4 as uuid } from 'uuid';
import { Input as AntInput, Button as AntButton, Form as AntForm, message, Select as AntSelect, Space, Table as AntTable } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const ESTADO_FACTURA = "estado-factura";
const ENVIO = "envio";
const NOTA = "nota";
const INTERNET = "internet";
const AGREGAR_MOVIL = "agregar-movil";
const GASTO_EXTRA = "gasto-extra";

const PILL_TODAS = "todas";
const PILL_DEVUELTAS = "devueltas";
const PERMISSIONS = [
  118946,
  118060,
  469,
  1
];
const ITEMS_PER_PAGE = [
  {
    value: 10,
    label: 10
  },
  {
    value: 20,
    label: 20
  },
  {
    value: 50,
    label: 50
  },
  {
    value: 100,
    label: 100
  },
  {
    value: 200,
    label: 200
  },
  {
    value: 1000,
    label: 1000
  },
  {
    value: 5000,
    label: 5000
  }
];
const DEBUG_MODE = window.location.host.includes("localhost") || window.location.host.includes("192.168.");
const API = !(DEBUG_MODE) ? "https://" + window.location.host + "/api/rest/" : "https://oficina.nadunet.es/api/rest/";
const columns = [
  {
    title: 'Negocio',
    dataIndex: 'business_name',
    key: 'business',
  },
  {
    title: 'Cuenta',
    dataIndex: 'account_name',
    key: 'account',
  },
  {
    title: 'NIF Proveedor',
    dataIndex: 'provider_nif',
    key: 'providerNIF',
  },
  {
    title: 'Número de factura',
    dataIndex: 'bill_number',
    key: 'invoiceNumber',
  },
  {
    title: 'Fecha',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'Descripción',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Concepto',
    dataIndex: 'concept_name',
    key: 'concept',
  },
  {
    title: 'Base imponible',
    dataIndex: 'base',
    key: 'taxableBase',
  },
  {
    title: 'Impuesto',
    dataIndex: 'tax',
    key: 'tax',
  },
  {
    title: 'Cuota',
    dataIndex: 'tax_amount',
    key: 'tax_amount',
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total',
  }
];

class BillsProviders extends React.Component {
  constructor(props) {
    super(props);
    if (!props.userData.isBillingDepartmentN2()) this.redirectTo("/dashboard");
    this.state = {
      error: [],
      ok: [],
      providers: [],
      savingOrders: [],
      savingProviders: [],
      accounts: [],
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      searchQuery: "",
      showPopUp: false,
      popUpConfirmation: null,
      popUpToShow: null,
      currentBillStatus: null,
      currentBillID: "",
      currentBillNumber: "",
      currentPill: PILL_TODAS,
      showItems: null,
      page: 1,
      pageItems: 10
    };
    ////console.log(props);
    this.redirectTo = this.redirectTo.bind(this);
    this.validateAllOrders = this.validateAllOrders.bind(this);
    
    this.getTaxesAndConcepts = this.getTaxesAndConcepts.bind(this);
    this.getProvidersBillingAccounts = this.getProvidersBillingAccounts.bind(this);
    this.createOrders = this.createOrders.bind(this);
    this.hasProviderError = this.hasProviderError.bind(this);
    this.hasExistingError = this.hasExistingError.bind(this);
    this.getOrderStatusIcon = this.getOrderStatusIcon.bind(this);
    this.isSavingOrder = this.isSavingOrder.bind(this);
    this.validateProvider = this.validateProvider.bind(this);
    this.createProvider = this.createProvider.bind(this);
    this.deleteOrder = this.deleteOrder.bind(this);
    this.searchBills = this.searchBills.bind(this);
  }
  componentDidMount() {
    this.getTaxesAndConcepts();
    this.getProvidersBillingAccounts();
    this.getProviders();
  }
  componentDidUpdate(prevProps, prevState) {
  }
  async getTaxesAndConcepts() {
    this.props.userData.getTaxesAndConcepts().then(result => {
      if (result.ok) {
        this.setState({
          taxes: result.taxes,
          concepts: result.concepts,
          business_lines: result.business_lines,
          charge_type: result.charge_type
        });
      } else {
        console.log("Something went wrong: " + result.error);
      }
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al obtener los impuestos y los conceptos: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
    // filter.page = filter.page - 1;
  }
  async getProvidersBillingAccounts() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": localStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let url = API + "nadunet_billing_resources/list_providers_billing_accounts";
    axios
      .post(url, {}, queryHeaders, { withCredentials: true })
      .then(result => {
        result = result.data;
        if (result.ok) {
          this.setState({ accounts: result.accounts });
        } else {
          message.error(result.error);
        }
      })
      .catch(error => {
        message.error(error.message);
      });
  }
  async getProviders() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": localStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let url = API + "nadunet_billing_resources/list_providers";
    axios
      .post(url, {}, queryHeaders, { withCredentials: true })
      .then(result => {
        result = result.data;
        if (result.ok) {
          this.setState({ providers: result.providers });
        } else {
          message.error(result.error);
        }
      })
      .catch(error => {
        message.error(error.message);
      });
  }
  async createOrders() {
    let orders = this.state.orders;
    this.setState({
      error: [],
      providers: [],
      savingOrders: Object.keys(orders)
    });
    orders = Object.keys(orders).map(id => {
      let order = orders[id];
      return {
        id: order.id,
        base: parseFloat(order.base).toString().replace(",", "."),
        bill_number: order.bill_number,
        billing_account: order.account.value,
        business_line: order.business_line.value,
        concept: order.concept.value,
        date: order.date.format('YYYY-MM-DD'),
        nif: order.nif,
        tax: order.tax.value,
        title: order.title
      };
    });
    // console.log("orders: ", orders);
    this.props.userData
      .createReceivedOrders(orders)
      .then(result => {
        if (result.ok) {
          result = result.result;
          this.setState({
            ok: result.ok,
            error: result.error,
            savingOrders: []
          });
          let okIds = Object.keys(result.ok);
          if (okIds) {
            okIds.map(id => {
              setTimeout(() => this.deleteOrder(id), 3000);
            });
          }
        } else {
          console.log("Something went wrong: " + result.error);
        }
      })
      .catch((error) => {
        // Error 😨
        console.log("Error al guardar las facturas de proveedores: " + error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
    // filter.page = filter.page - 1;
  }
  async createProvider(nif) {
    let providers = this.state.providers;
    if (!providers) return;
    let provider = providers[nif];
    if (!provider) return;

    let request = {
      nif: nif,
      name: provider.name,
      charge_type: provider.charge_type.value
    };
    let savingProviders = this.state.savingProviders;
    if (!savingProviders) savingProviders = [];
    if (savingProviders[nif]) return;
    savingProviders[nif] = true;
    this.setState({
      savingProviders: savingProviders
    });
    this.props.userData
      .createProvider(request)
      .then(result => {
        let savingProviders = this.state.savingProviders;
        if (!savingProviders) savingProviders = [];
        savingProviders[nif] = false;
        this.setState({
          savingProviders: savingProviders
        });
        if (result.ok) {
          let providers = this.state.providers;
          providers[nif].created = true;
          this.setState({
            providers: providers
          });
        } else {
          let providers = this.state.providers;
          providers[nif].error = result.error;
          this.setState({
            providers: providers
          });
        }
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar las facturas de proveedores: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
    // filter.page = filter.page - 1;
  }
  deleteOrder(id) {
    let orders = this.state.orders;
    let newOrders = [];
    Object.keys(orders).map(itemKey => {
      if (itemKey !== id) newOrders[itemKey] = orders[itemKey];
    });
    this.setState({ orders: newOrders });
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  validateOrder(order) {
    if (!order) return false;
    if (!order.business_line) return false;
    if (!order.nif || order.nif.length < 2) return false;
    if (!order.bill_number || order.bill_number.length < 1) return false;
    if (!order.date || order.date.length < 2) return false;
    if (!order.title || order.title.length < 2) return false;
    if (!order.concept) return false;
    if (!order.tax) return false;
    if (!order.base) return false;
    if (!order.account) return false;
    if (this.hasProviderError(order)) return false;
    if (this.hasExistingError(order)) return false;
    return true;
  }
  validateAllOrders() {
    let orders = this.state.orders;
    if (!orders || Object.keys(orders).length < 1) return false;
    let ids = Object.keys(orders);
    for (let i = 0; i < ids.length; i++) {
      const order = orders[ids[i]];
      if (!this.validateOrder(order)) return false;
    }
    return true;
  }
  validateProvider(provider) {
    if (!provider) return false;
    let providerName = provider.name;
    if (!providerName) return false;
    if (providerName && providerName.length < 3) return false;
    if (!provider.charge_type) return false;
    return true;
  }
  hasProviderError(order) {
    let errors = this.state.error[order.id];
    let providers = this.state.providers;
    if (!errors || errors.length === 0) return false;
    for (let i = 0; i < errors.length; i++) {
      const error = errors[i];
      if (error.type === "provider") {
        if (order.nif in providers) {
          if (providers[order.nif].canceled) return false;
          if (providers[order.nif].created) return false;
          // let providerName = providers[order.nif].name;
          // if (providerName && providerName.length > 3) return false;
          return true;
        } else {
          return true;
        }
      }
    }
    return false;
  }
  hasExistingError(order) {
    let errors = this.state.error[order.id];
    if (!errors || errors.length === 0) return false;
    for (let i = 0; i < errors.length; i++) {
      const error = errors[i];
      if (error.type === "existing") return true;
    }
    return false;
  }
  getOrderStatusIcon(order) {
    let validated = this.validateOrder(order);
    let isSaving = this.isSavingOrder(order);
    if (isSaving) return <i className="now-ui-icons arrows-1_refresh-69 spin" />;
    if (validated) return <i className="now-ui-icons ui-1_check color-primary" />;
    // if (this.state.providers && this.state.providers[order.nif]) {
    //   if (this.state.providers[order.nif].created) {
    //     return <i className="now-ui-icons ui-1_check color-primary" />;
    //   }
    // }
    return <i className="now-ui-icons ui-1_bell-53 color-warning" />;
  }
  isSavingOrder(order) {
    if (!order) return false;
    if (!this.state.savingOrders) return false;
    return this.state.savingOrders.includes(order.id);
  }
  createOrdersTable() {
    // return (
    //   <BillsTable
    //     showCustomer
    //     bills={this.state.pages[this.state.page]}
    //     userData={this.props.userData}
    //     reloadEntityCallback={this.reloadOrder}
    //   />
    // );
    let orders = this.state.orders;
    let ordersRows = null;
    let providerErrors = [];
    if (orders && Object.keys(orders).length > 0) {
      ordersRows = Object.keys(orders).map(id => {
        let order = orders[id];
        let hasProviderError = this.hasProviderError(order);
        let hasExistingError = this.hasExistingError(order);
        let isSaving = this.isSavingOrder(order);
        let orderRow = null;
        let isOkOrder = order.id in this.state.ok;
        if (!isOkOrder) {
          orderRow = (
            <tr key={id}>
              <td>{this.getOrderStatusIcon(order)}</td>
              <td>
                <Select
                  disabled={isSaving}
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Negocio"
                  name="negocio"
                  value={order.business_line}
                  options={this.state.business_lines}
                  onChange={value =>{
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.business_line = value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                  }}
                />
              </td>
              <td>
                <Select
                  disabled={isSaving}
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Cuenta"
                  name="cuenta"
                  value={order.account}
                  options={this.state.accounts}
                  onChange={value =>{
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.account = value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                  }}
                />
              </td>
              <td>
                <Input
                  disabled={hasProviderError || isSaving}
                  type="text" 
                  value={order.nif || ""}
                  placeholder={"NIF proveedor"}
                  onChange={(e) => {
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.nif = e.target.value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                  }}
                />
              </td>
              <td>
                <Input 
                  disabled={isSaving}
                  type="text" 
                  value={order.bill_number || ""}
                  placeholder={"Nº factura"}
                  onChange={(e) => {
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.bill_number = e.target.value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                  }}
                />
              </td>
              <td>
                <Datetime
                  disabled={isSaving}
                  timeFormat={false}
                  inputProps={{ placeholder: "Selecciona la fecha" }}
                  value={order.date}
                  onChange={value => {
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.date = value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                    // this.setState({ date_day: value });
                  }}
                />
              </td>
              <td>
                <Input 
                  disabled={isSaving}
                  type="text" 
                  value={order.title || ""}
                  placeholder={"Descripción"}
                  onChange={(e) => {
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.title = e.target.value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                  }}
                />
              </td>
              <td>
                <Select
                  disabled={isSaving}
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Concepto"
                  name="concepto"
                  value={order.concept}
                  options={this.state.concepts}
                  onChange={value =>{
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.concept = value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                  }}
                />
              </td>
              <td>
                <Input 
                  disabled={isSaving}
                  type="number" 
                  value={order.base || ""} 
                  onChange={(e) => {
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.base = e.target.value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                  }}
                />
              </td>
              <td>
                <Select
                  disabled={isSaving}
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Impuesto"
                  name="impuesto"
                  value={order.tax}
                  options={this.state.taxes}
                  onChange={value =>{
                    let orders = this.state.orders;
                    let order = orders[id];
                    order.tax = value;
                    orders[id] = order;
                    this.setState({ orders: orders });
                  }}
                />
              </td>
              <td>
                <Button round icon color="info"
                  disabled={isSaving}
                  onClick={e => {
                    let newOrder = {
                      id: uuid(),
                      account: order.account,
                      base: order.base,
                      bill_number: order.bill_number,
                      business_line: order.business_line,
                      concept: order.concept,
                      date: order.date,
                      nif: order.nif,
                      tax: order.tax,
                      title: order.title
                    };
                    let orders = this.state.orders;
                    if (!orders) orders = [];
                    orders[newOrder.id] = newOrder;
                    this.setState({ orders: orders });
                  }}>
                  <i className="now-ui-icons files_single-copy-04" />
                </Button>
                {" "}
                <Button 
                  disabled={isSaving}
                  round 
                  icon 
                  color="danger"
                  onClick={e => {
                      this.deleteOrder(id);
                    }}
                  >
                  <i className="now-ui-icons ui-1_simple-remove" />
                </Button>
              </td>
            </tr>
          );
        } else {
          orderRow = (
            <tr key={id} className="received-bill-ok">
              <td>{this.getOrderStatusIcon(order)}</td>
              <td colSpan={9}>
                <span className="received-bill-message">
                  ¡Factura guardada correctamente!
                </span>
              </td>
            </tr>
          );
        }
        let errorRow = null;
        let providerRow = null;
        let existingRow = null;
        if (hasProviderError || hasExistingError) {
          errorRow = (
            <tr key={id + "-error"} className="provider-order-error">
              <td colSpan={99}>
                <b>Error al guardar la factura:</b>
              </td>
            </tr>
          );
          if (hasProviderError) {
            let providerAlreadyAsked = order.nif in providerErrors;
            providerErrors[order.nif] = true;
            let providerName = "";
            let providerType = null;
            let providers = this.state.providers;
            if (providers && order.nif in providers) {
              providerName = providers[order.nif].name;
              providerType = providers[order.nif].charge_type;
            }
            // console.log("Creating provider row");
            let isSavingProvider = this.state.savingProviders && this.state.savingProviders[order.nif];
            providerRow = (
              <tr key={id + "-create-provider"} className="provider-order-error">
                <td></td>
                <td colSpan={providerAlreadyAsked ? 9 : 3}>
                  El proveedor no está dado de alta, indica el nombre para crearlo.
                  {providerAlreadyAsked ? " Mismo NIF de proveedor. Formulario de alta mostrado en otra factura." : ""}
                </td>
                {!providerAlreadyAsked && <td colSpan={1}>
                  <Select
                    disabled={isSavingProvider}
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Tipo"
                    name="tipo_proveedor"
                    value={providerType}
                    options={this.state.charge_type}
                    onChange={value =>{
                      let providers = this.state.providers;
                      if (!providers) providers = [];
                      if (!providers[order.nif]) {
                        providers[order.nif] = {
                          name: "",
                          created: false,
                          canceled: false,
                          charge_type: null
                        };
                      }
                      providers[order.nif].charge_type = value;
                      this.setState({ providers: providers });
                    }}
                  />
                </td>}
                {!providerAlreadyAsked && <td colSpan={3}>
                  <Input 
                    disabled={isSavingProvider}
                    type="text" 
                    value={providerName}
                    placeholder={"Nombre del proveedor"}
                    onChange={(e) => {
                      let providers = this.state.providers;
                      if (!providers) providers = [];
                      if (!providers[order.nif]) {
                        providers[order.nif] = {
                          name: "",
                          created: false,
                          canceled: false,
                          charge_type: null
                        };
                      }
                      providers[order.nif].name = e.target.value;
                      this.setState({ providers: providers });
                    }}
                  />
                </td>}
                {!providerAlreadyAsked && <td colSpan={1}>
                  <Button block round color="primary"
                    disabled={!this.validateProvider(this.state.providers[order.nif]) || isSavingProvider}
                    onClick={e => {
                      this.createProvider(order.nif);
                      }}
                    >
                    <i className={"now-ui-icons " + (isSavingProvider ? "arrows-1_refresh-69 spin" : "ui-1_simple-add")} />{" "} Dar de alta
                  </Button>
                </td>}
                {!providerAlreadyAsked && <td colSpan={1}>
                  <Button block round color="danger"
                    disabled={isSavingProvider}
                    onClick={e => {
                        let errors = this.state.error;
                        let ids = Object.keys(errors);
                        let newErrors = [];
                        ids.map(currentId => {
                          if (currentId !== id) newErrors[currentId] = errors[currentId];
                        });
                        this.setState({ error: newErrors });
                        let providers = this.state.providers;
                        if (!providers) providers = [];
                        if (!providers[order.nif]) {
                          providers[order.nif] = {
                            name: "",
                            created: false,
                            canceled: false
                          };
                        }
                        providers[order.nif].canceled = true;
                        this.setState({ providers: providers });
                      }}
                    >
                    <i className="now-ui-icons ui-2_settings-90" />{" "} No, cambiar NIF
                  </Button>
                </td>}
              </tr>
            );
          }
          if (hasExistingError) {
            existingRow = (
              <tr key={id + "-create-provider"} className="provider-order-error">
                <td></td>
                <td colSpan={9}>
                  Ya existe otra factura de este proveedor con la misma fecha y numeración.
                </td>
              </tr>
            );
          }
        }
        
        return [orderRow, (isOkOrder ? <tr></tr> : null), <tr></tr>, errorRow, <tr></tr>, providerRow, <tr></tr>, existingRow];
      });
    }
    let ordersTable = (
      <Table striped size="sm" responsive="md">
        <thead>
          <tr>
            <th></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Negocio</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Cuenta</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>NIF Proveedor</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Nº factura</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Fecha</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Descripción</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Concepto</b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Importe <Label>Sin IVA</Label></b></th>
            <th><span className="item-related table-header color-danger">Obligatorio</span><br /><b>Impuesto</b></th>
            <th><br /><b>Acciones</b></th>
          </tr>
        </thead>
        <tbody>
          {ordersRows}
          <tr>
            <td className="text-center" colSpan={15}>
              <Button 
                round 
                color="primary"
                disabled={!this.validateAllOrders()}
                onClick={e => {
                  this.createOrders();
                  }}
                >
                <i className="now-ui-icons arrows-1_cloud-upload-94" />{" "} Guardar facturas
              </Button>
              {" "}
              <Button round color="default"
                onClick={e => {
                    let newOrder = {
                      id: uuid(),
                      nif: "",
                      bill_number: "",
                      date: null,
                      title: "",
                      concept: null,
                      base: 0,
                      tax: null
                    }
                    let orders = this.state.orders;
                    if (!orders) orders = [];
                    orders[newOrder.id] = newOrder;
                    this.setState({ orders: orders });
                  }}
                >
                <i className="now-ui-icons ui-1_simple-add" />{" "} Añadir factura
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
    );
    return (
      <Card>
        <CardBody className="table-full-width">
          {ordersTable}
        </CardBody>
      </Card>
    );
  }
  filterBills(bill) {
    if (!this.state.textFilter) return true;
    // let debtorText = JSON.stringify(debtor).toLowerCase();
    let textFilter = this.state.textFilter;
    let bill_json = "";
    // console.log("note_text", note_text);
    try {
      bill_json = JSON.stringify(bill).toLowerCase();
      // console.log("note_json", note_json);
      // note_text = note_json.text;
    } catch (error) {
      console.log("Error parsing debtor to JSON", { error: error, bill: bill });
      // note_text = note.texto;
    }

    let subFilters = textFilter.toLowerCase().split(" ");
    let result = true;
    if (!subFilters || subFilters.length === 0) {
      return result;
    }
    // console.log("subFilters",subFilters);
    subFilters.map(filter => {
      let localResult = false;
      if (bill_json.includes(filter)) localResult = true;
      // Si cualquiera de las condiciones se cumple, devuelve TRUE
      // if (note_text.toLowerCase().includes(filter)) localResult = true;
      // if (note.fecha.toLowerCase().includes(filter)) localResult = true;
      // if (note.tipo.toLowerCase().includes(filter)) localResult = true;
      // if (note_text.toLowerCase().includes(filter)) localResult = true;
      // if (note.autor.toLowerCase().includes(filter)) localResult = true;
      // if (note.titulo.toLowerCase().includes(filter)) localResult = true;

      result = result && localResult;
    });
    return result;
  }
  handleBillNumberChange = (e) => {
    this.setState({ invoiceNumber: e.target.value });
  };
  handleBillAccountChange = (value) => {
    this.setState({ billAccount: value });
  };
  handleBillProviderChange = (value) => {
    this.setState({ billProvider: value });
  };
  filterOptions = (input, option) => {
    return option.label.toLowerCase().includes(input.toLowerCase());
  };
  buildFilter() {
    const { searching, invoiceNumber, billAccount, billProvider } = this.state;
    return (
      <AntForm layout="inline">
        <AntForm.Item>
          <AntInput
            placeholder="Número de factura"
            value={invoiceNumber}
            onChange={this.handleBillNumberChange}
          />
        </AntForm.Item>
        <AntForm.Item>
          <AntSelect
            mode="multiple"
            placeholder="Elige proveedor"
            value={billProvider}
            onChange={this.handleBillProviderChange}
            options={this.state.providers}
            style={{ minWidth: 160 }}
            allowClear
            showArrow
            filterOption={this.filterOptions}
          />
        </AntForm.Item>
        <AntForm.Item>
          <AntSelect
            mode="multiple"
            placeholder="Elige cuenta"
            value={billAccount}
            onChange={this.handleBillAccountChange}
            options={this.state.accounts}
            style={{ minWidth: 160 }}
            allowClear
            showArrow
            filterOption={this.filterOptions}
          />
        </AntForm.Item>
        <AntForm.Item>
          <AntButton type="primary" icon={<SearchOutlined />} onClick={() => this.searchBills()} loading={searching} disabled={searching}>
            Buscar
          </AntButton>
        </AntForm.Item>
      </AntForm>
    );
  }
  searchBills() {
    let searching = this.state.searching;
    if (searching) return;
    this.setState({ searching: true });
    const { invoiceNumber, billAccount, billProvider } = this.state;
    let search = {
      bill_number: invoiceNumber
    };
    if (billAccount && billAccount.length > 0) {
      search.bill_account = billAccount;
    }
    if (billProvider && billProvider.length > 0) {
      search.bill_provider = billProvider;
    }
    let request = {
      search: search
    };
    // return;
    let url = API + "nadunet_billing_resources/search_providers_bills";
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": localStorage.getItem("token"),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({ searching: false });
        result = result.data;
        if (result.ok) {
          this.setState({
            searchedBills: Object.values(result.orders)
          });
          return;
        } else {
          message.error(result.error);
        }
      })
      .catch(error => {
        this.setState({ searching: false });
        message.error(error.message);
      });
  }
  buildProvidersBills(bills) {
    return <AntTable columns={columns} dataSource={bills} />;
  }
  render() {
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
    }

    let buttonAttributes = {
      xs: 6,
      md: 4,
      lg: 3,
      className: "text-center hover-card"
    };
    let filterField = this.buildFilter();
    let content = null;
    let bills = this.state.searchedBills;
    content = this.buildProvidersBills(bills);
    return (
      <div>
      <PanelHeader
        size="sm"
      />
        <div className="content">
          <Row>
            <Col {...buttonAttributes}>
              <Card>
                <CardBody>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="business_briefcase-24"
                    title="Proveedores"
                    subtitle="Facturas de proveedores"
                  />
                </CardBody>
              </Card>
            </Col>
            <Col xs={12}>
              <h5>Añadir facturas</h5>
            </Col>
            <Col xs={12}>{this.createOrdersTable()}</Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <h5>Buscador de facturas</h5>
                  {filterField}
                </CardBody>
              </Card>
            </Col>
            <Col xs={12}>{content}</Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default BillsProviders;



// WEBPACK FOOTER //
// ./src/views/Bills/BillsProviders.jsx